var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-repeat=\"(key, el) in vm.parameter[vm.key].wert\"><br><div ng-if=\"el.typ === 'richtext' &amp;&amp; el.wert != ''\"><strong>{{ el.bez }}:</strong><span ng-bind-html=\"el.wert\"></span></div><div ng-if=\"el.typ !== 'richtext' || el.wert == ''\"><p>\"{{ key }}\":<div ng-bind=\"el | json:2\" style=\"max-height: 150px; width: 100%;\" class=\"code-content scroll-content\"></div></p></div></div>");;return buf.join("");
}